export const ACTION_MENUS_INIT = 'ACTION_MENUS_INIT';
export const OPEN_ACTION_MENU = 'OPEN_ACTION_MENU';
export const CLOSE_ACTION_MENU = 'CLOSE_ACTION_MENU';
